import axios from 'axios';

const API_BASE_URL = 'http://localhost:4000/api';

// Origin that serves uploaded assets (the API base without the `/api` suffix).
export const ASSET_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

// Resolve a stored image path to a full URL. Relative paths (e.g. `/uploads/x.jpg`)
// are prefixed with the backend origin; absolute/data URLs are returned untouched.
export const resolveAssetUrl = (url) => {
  if (!url) return url;
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
  return `${ASSET_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post('/auth/login', { email, password });

// Public Blogs
export const getBlogs = (category) =>
  api.get('/blogs', { params: category ? { category } : {} });

export const getBlogBySlug = (slug) => api.get(`/blogs/slug/${slug}`);

// Admin Blogs
export const getAdminBlogs = () => api.get('/blogs/admin/all');
export const createBlog = (data) => api.post('/blogs', data);
export const updateBlog = (id, data) => api.put(`/blogs/${id}`, data);
export const deleteBlog = (id) => api.delete(`/blogs/${id}`);

// Image upload
export const uploadImage = (formData) =>
  api.post('/uploads/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Events (public)
export const getEvents = () => api.get('/events');
export const getEvent = (id) => api.get(`/events/${id}`);

// Events (admin)
export const createEvent = (data) => api.post('/events', data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data);
export const deleteEvent = (id) => api.delete(`/events/${id}`);

export const exportEventRegistrations = (id) =>
  api.get(`/events/${id}/registrations/export`, { responseType: 'blob' });

// Events (member)
export const registerForEvent = (id) => api.post(`/events/${id}/register`);
export const unregisterFromEvent = (id) => api.delete(`/events/${id}/register`);
export const checkRegistered = (id) => api.get(`/events/${id}/registered`);
export const getMyEventRegistrations = () => api.get('/events/my/registrations');

// Admin Stats & Users
export const getStats = () => api.get('/admin/stats');
export const getUsers = () => api.get('/admin/users');
export const createMember = (data) => api.post('/admin/users', data);
export const deleteMember = (id) => api.delete(`/admin/users/${id}`);
export const setMemberStatus = (id, isActive) =>
  api.patch(`/admin/users/${id}/status`, { isActive });
export const setMemberPassword = (id, password) =>
  api.patch(`/admin/users/${id}/password`, { password });

export default api;
